import {
  createPath,
  Link as RouterLink,
  LinkProps,
  useLocation,
} from 'react-router'
import { INFLUENCER, NYCA, PHIL_MV } from 'utils/constants/Helpers'
import useInfluencerFlow from './useCustomNavigate'

const Link = (linkProps: LinkProps) => {
  const location = useLocation()
  const { isInfluencerFlow } = useInfluencerFlow()
  const isNyCa = location?.pathname.includes(NYCA)
  const locationGroup = isNyCa ? NYCA : PHIL_MV

  const path =
    typeof linkProps.to === 'string' ? linkProps.to : createPath(linkProps.to)

  return (
    <RouterLink
      {...linkProps}
      to={isInfluencerFlow ? `${INFLUENCER}${locationGroup}${path}` : path}
    >
      {linkProps.children}
    </RouterLink>
  )
}

export default Link
